<template>
		<div>
			<main style='background: #EEEEEE;height: 900px;'>
					<img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
					<div class="centerBox">
						<div class="liucheng">
							<div>
								<p style="width: 100%;text-align: center;font-size: 30px;
font-family: Microsoft YaHei, Microsoft YaHei-Bold;
font-weight: 700;
text-align: center;
color: #333333;
line-height: 24px;
letter-spacing: 2px;margin-bottom: 40px;">河北鹿泉司法鉴定联合服务团</p>
								<p style="width:100%;font-size: 16px;font-family: Microsoft YaHei, Microsoft YaHei-Regular;font-weight: 400;text-align: left;color: #333333;line-height: 30px;letter-spacing: 1px;">
								    <img src="../../../images/pic_lhfwt.png" align="left" width="258" hspace="5" vspace="5" style="margin-right: 25px;">
								    在省司法厅司法鉴定管理部门的精心指导下，石家庄市司法局的大力支持下，河北中经天平司法鉴定中心、河北中旭生态环境损害司法鉴定中心、河北华科大司法鉴定中心、鹿泉燕赵司法鉴定中心四家鉴定机构，以联盟链的方式参与到此次雄安区块链的建设当中。联盟链对接并应用了雄安新区区块链底层技术，并结合电子签名、可信时间戳、哈希值校验等技术，将电子数据加密保全，实时同步到雄安区块链，应用区块链去中心化、不可篡改、不可逆以及可追溯的特性，有效防止电子数据被篡改，保障了电子数据的真实性、完整性和原始性。另外，联盟内链数据同时已与中经天平司法电子证据平台打通，当事人可一键递交电子证据到全国各级人民法院电子证据平台，为真正服务诉讼活动、方便群众维权提供了高效率的技术保障。 目前，联盟链已实现包括司法鉴定意见书，电子物证类数据存认证上链，并通过证据保全、证据核验、网上立案、网上开庭来实现司法业务的证据认定和多部门间证据互认。下一步，四家司法鉴定机构将不断自我完善，自我革新，持续在实践中深耕探索司法区块链应用向纵深发展的服务模式，使更加公平、更加优质、更加快捷的服务能力成为我省司法鉴定行业健康有序发展的突出亮点。
								</p>
							</div>
						</div>
					</div>
			</main>
		</div>
</template>

<script>

import navheader from '../../components/navheader.vue'
import footeritem from '../../components/footeritem.vue'
import axios from 'axios'
import '../../assets/css/index.less'
import '../../assets/css/fuWu.less';
export default {
	name: 'Pdf',
	components: {
		navheader,
		footeritem
	},
	data() {
		return {
			activeNum: 0,
			list: [
				{ name: '关于协会' },
				{ name: '协会简介' },
				{ name: '协会章程' },
				{ name: '组织机构' },
				{ name: '理事会' },
				{ name: '秘书处' },
				],
		};
	},
	methods: {
		select (item, index) {
		  this.activeNum = index
		  if (index === 1) {
		    setTimeout(() => {
		      var map = new BMap.Map("container");    
		      var point = new BMap.Point(114.662576,38.044547);    
		      map.centerAndZoom(point, 15); 
		      var opts = {anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_LARGE} 
		      map.addControl(new BMap.NavigationControl(opts));
		      var marker = new BMap.Marker(point);
		      map.addOverlay(marker);  
		      map.enableScrollWheelZoom(true);
		      var information = {    
		        width : 200,     // 信息窗口宽度    
		        height: 100,     // 信息窗口高度 
		        offset: {height: -20, width: 0}
		      }
		      var html = `<div class="baidu-map">
		        <p>
		          中经天平司法鉴定中心
		        </p>
		        <p>
		          长江大道315号创新大厦A座9-903室
		        </p>
		        <p>
		          联系电话：0311-89929485
		        </p>
		      </div>
		      `
		      var infoWindow = new BMap.InfoWindow(html, information);  // 创建信息窗口对象    
		      map.openInfoWindow(infoWindow, map.getCenter());
		      marker.addEventListener("click", function() {
		        var information = {    
		          width : 200,     // 信息窗口宽度    
		          height: 90,     // 信息窗口高度 
		        }
		        var infoWindow = new BMap.InfoWindow(html, information);
		        // 调用了marker对象的openInfoWindow方法
		        this.openInfoWindow(infoWindow); 
		      });
		    }, 200)
		  }
		  }
	},
	created(){
		
	},
	mounted() {
		let that = this;
	},
};
</script>

<style lang="less" scoped="scoped">
	.topImg{
		width: 100%;
		display: block;
	}
	.centerBox{
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}
	.titleTip{
		width: 100%;
		border-left: 4px solid #01458E;
		padding-left: 10px;
	}
	.liucheng {
		position: absolute;
		top: 300px;
		
	  // background: #F8F8F8;
	  // padding: 30px 0;
	  &>div {
	    width: 1134px;
		height: 700px;
	    margin: 0 auto;
	    padding: 60px 90px;
		border-radius: 20px;
	    box-sizing: border-box;
	    // border-radius: 10px;
	    background: #fff;
	    overflow: hidden;
	    &>ul {
	      float: left;
	      &>li {
	        width: 150px;
	        line-height: 50px;
	        text-align: center;
	        cursor: pointer;
	        position: relative;
	        &::after {
	          position: absolute;
	          right: -16px;
	          top: 16px;
	          display: inline-block;
	          content: '';
	          border: 8px solid transparent;
	        }
	        &.active {
	          background: #076CE0;
	          color: #fff;
	          &::after {
	            border-left-color: #076CE0;
	          }
	        }
	      }
	    }
	    &>div {
	      width: calc(100% - 300px);
	          padding: 20px;
	          box-sizing: border-box;
	          padding-top: 0;
			  float: right;
			  overflow: hidden;
	      .lianxi {
	        p {
	          span {
	            display: inline-block;
	            width: 80px;
	            text-align: right;
	            margin-right: 20px;
	          }
	          margin-top: 20px;
	        }
	      }
	    }
	  }
	  @media screen and (max-width: 1024px) {
	    &>div {
	      width: 90%;
	    }
	  }
	}
</style>
